module.exports = __webpack_public_path__ + "static/media/korean-alphabet.a151360d.jpg";